import { CONNECTION } from "../../config/Connections";
import { CONFIG_ } from "../../config/Config";
import { successnotify, warningnotify } from "../../components/ToasNotif/Toast";
import { __openModal } from "../Modal";

var get = "/typepelajaran";
var post = "/typepelajaran";
export const actGetDataTypepelajaran = () => {
  return (dispatch) => {
    let config = CONFIG_({ url: get, method: "GET" });
    dispatch({ type: "LOADING_TYPEPELAJARAN" });
    CONNECTION(config)
      .then((response) => {
        const { status, data } = response;
        if (status === 200) {
          return dispatch({
            type: "SUCCESS_TYPEPELAJARAN",
            message: "Success get data",
            data: data,
            code: status,
          });
        }
        return dispatch({ type: "ERROR_TYPEPELAJARAN", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPEPELAJARAN",
          message: "Network error..",
        });
      });
  };
};

export const actPostDataTypepelajaran = (params) => {
  return (dispatch) => {
    let config = CONFIG_({ url: post, data: params, method: "POST" });
    dispatch({ type: "LOADING_TYPEPELAJARAN" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Lesson type has been created");
          dispatch(
            __openModal({ modal: "MODAL_ADD_TYPEPELAJARAN", open: false })
          );
          return dispatch(actGetDataTypepelajaran());
        }
        warningnotify(response.message);
        return dispatch({ type: "ERROR_TYPEPELAJARAN", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPEPELAJARAN",
          message: "Network error..",
        });
      });
  };
};

export const actUpdateDataTypepelajaran = (params) => {
  return (dispatch) => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, data: params, method: "PUT" });
    dispatch({ type: "LOADING_TYPEPELAJARAN" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Lesson type has been updated");
          dispatch(
            __openModal({ modal: "MODAL_EDIT_TYPEPELAJARAN", open: false })
          );
          return dispatch(actGetDataTypepelajaran());
        }
        warningnotify(response.message);
        return dispatch({ type: "ERROR_TYPEPELAJARAN", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPEPELAJARAN",
          message: "Network error..",
        });
      });
  };
};

export const actDetailDataTypepelajaran = (params) => {
  return (dispatch) => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, method: "GET" });
    dispatch({ type: "LOADING_TYPEPELAJARAN" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          return dispatch({
            type: "SUCCESS_TYPEPELAJARAN",
            message: "Success get data",
          });
        }
        return dispatch({ type: "ERROR_TYPEPELAJARAN", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPEPELAJARAN",
          message: "Network error..",
        });
      });
  };
};

export const actDeleteDataTypepelajaran = (params) => {
  return (dispatch) => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, method: "DELETE" });
    dispatch({ type: "LOADING_TYPEPELAJARAN" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Lesson type has been deleted");
          return dispatch(actGetDataTypepelajaran());
        }
        warningnotify(response.message);
        return dispatch({ type: "ERROR_TYPEPELAJARAN", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPEPELAJARAN",
          message: "Network error..",
        });
      });
  };
};
